import {
	Component,
	ElementRef,
	EventEmitter,
	HostListener,
	inject,
	input,
	Input,
	Output,
	signal,
	ViewChild,
	ViewEncapsulation,
	WritableSignal
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MDIconComponent } from '@melodic-ui/components';

@Component({
	selector: 'lb-search-bar',
	standalone: true,
	imports: [CommonModule, MDIconComponent],
	templateUrl: './search-bar.component.html',
	styleUrl: './search-bar.component.scss',
	encapsulation: ViewEncapsulation.None
})
export class SearchBarComponent {
	private eRef: ElementRef = inject(ElementRef);

	@Input() showClearButton = false;
	placeholder = input<string | null>(null);

	private _value: WritableSignal<string | null> = signal(null);

	@Input()
	set value(val: string | null) {
		this._value.set(val);
	}

	get value(): string | null {
		return this._value();
	}

	@Output() readonly changed: EventEmitter<string | null> = new EventEmitter<string | null>();

	@ViewChild('inputElement', { static: false }) inputElementRef!: ElementRef<HTMLInputElement>;
	isFocused: WritableSignal<boolean> = signal(false);

	getClasses() {
		return {
			focused: this.isFocused()
		};
	}

	onInputChange(event: Event) {
		const inputElement = event.target as HTMLInputElement;
		const newValue = inputElement?.value || '';
		this.changeValue(newValue);
	}

	focusInput() {
		this.isFocused.set(true);
		this.inputElementRef.nativeElement.focus();
	}

	toggleVisibility() {
		this.isFocused.set(!this.isFocused());
	}

	clear() {
		this.isFocused.set(false);
		this.changeValue(null);
	}

	private changeValue(value: string | null) {
		this._value.set(value);
		this.changed.emit(value);
	}

	@HostListener('document:click', ['$event.target'])
	onClick(targetElement: EventTarget | null) {
		if (!targetElement) return;
		const clickedInside = this.eRef.nativeElement.contains(targetElement as Node);
		clickedInside ? this.isFocused.set(true) : this.isFocused.set(false);
	}
}
